export const Ngodata = {
    cardData: [
        {
            id: 1,
            img: 'https://media.istockphoto.com/id/535555239/photo/happy-indian-school-children.jpg?s=612x612&w=0&k=20&c=fcpTUHiHJuaeRS-xHJy4oOflwKpBooiPecyewzohvhk=',
            title: 'Give Help welfare society',
            desc: ' Address: 127/470, w-1 Saket Nagar, ',
            desc2: 'Kanpur, Uttar Pradesh 208014 India',
            contact: 'Contact No: 85744 62790',
            link: 'https://give-help-welfare-society.business.site/'
        },
        {
            id: 2,
            img: 'https://www.youngisthan.in/wp-content/uploads/2018/10/ngo-970x582.jpg',
            title: 'HUMSAFAR',
            desc: ' Address: C-80, Flat no. 2, Sector -A, Mahanagar',
            desc2: 'Lucknow, Uttar Pradesh, India - 226006',
            contact: 'Contact No: 0522-2205215',
            link: 'https://www.humsafarindia.org/'
        },
        {
            id: 3,
            img: 'https://youngscholarz.com/wp-content/uploads/2021/10/education.jpeg',
            title: 'Jivanamasteya',
            desc: 'Address: 10/D, Shri Kunthunath Tower, Umra,',
            desc2: 'Surat - 395007. Gujarat. India',
            contact: 'Email: info@JivanamAsteya.org',
            link: 'https://jivanamasteya.org/'
        },
        {
            id: 4,
            img: 'https://s3.youthkiawaaz.com/wp-content/uploads/2019/05/28110059/Photo-of-NGO.jpg',
            title: 'Minerva',
            desc: 'Address: Sultanpur, Danapur Nizamat, Danapur, ',
            desc2: 'Bihar -801503 India',
            contact: 'Contact No:  075430 35991',
            link: 'https://jivanamasteya.org/'
        },
        {
            id: 5,
            img: 'https://borgenproject.org/wp-content/uploads/Educating-children-in-India.jpg',
            title: 'Majlis Manch',
            desc: 'Address: Bldg 4 Flat A/2 Golden Valley, ',
            desc2: ' Kalina Kurla Road, Santacruz (E) Mumbai 98 ',
            contact: 'Contact No:  2666 1252 ',
            link: 'https://majlislaw.com/'
        },
        {
            id: 6,
            img: 'https://static8.depositphotos.com/1037087/976/i/450/depositphotos_9763937-stock-photo-indian-students-smiling.jpg',
            title: 'Apnalaya',
            desc: 'Address: B/9-103, New Jaiphalwadi SRA Co-op Housing Society Behind Police Quarters,',
            desc2: 'Tardeo, Mumbai 400036 Maharashtra',
            contact: 'Contact No: +91 22 23539752',
            link: 'https://www.giveindia.org/nonprofit/apnalaya'
        },
        {
            id: 7,
            img: 'https://media.istockphoto.com/id/1324689337/photo/indian-village-government-school-girls-operating-laptop-computer-system-at-rural-area-in-india.webp?b=1&s=170667a&w=0&k=20&c=v8GDfDRKYXen5I4tF7B48KT8rKmXzpRK_BifBCkTOUE=',
            title: 'ActionAid',
            desc: 'Address: R-7 Hauz Khas Enclave, ',
            desc2: 'New Delhi, Pincode, 110016',
            contact: 'Contact No: +91 11 40640500',
            link: 'https://www.actionaidindia.org/'
        },
        {
            id: 8,
            img: 'https://www.worldbank.org/content/dam/Worldbank/Feature%20Story/sar/india/india-education-brief.jpg',
            title: 'Sayodhya',
            desc: 'Address: 95, Prakashnagar Upparapally, Rajendranagar Mandal ,',
            desc2: 'Hyderabad, Telangana, India, 500013',
            contact: 'Contact No: +919490192119',
            link: 'https://sayodhya.org'
        },
        {
            id: 9,
            img: 'https://media.istockphoto.com/id/535896491/photo/raising-hands.jpg?s=612x612&w=0&k=20&c=lIZEfml2bHaHTXNB_e-sTjCQY0ysRXB3FH3QCFhhQek=',
            title: 'Urja Trust Foundation',
            desc: 'Address: 29/A, Latif villa compound, Dada Saheb Phalke road, ',
            desc2: 'Dadar east, Mumbai 400014',
            contact: 'Email:  connect@urjatrust.org',
            link: 'https://www.urjatrust.org/'
        },

    ]
}
